var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('side-bar'),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Nouvelle campagne")]),(_vm.campaign)?_c('CampaignForm',{attrs:{"campaign":_vm.campaign,"scope":'new'}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }